import { useEffect } from 'react';

let bypassBeforeUnload = false;

export const bypassUnsavedChangesWarning = () => {
  bypassBeforeUnload = true;
};

export const useBeforeUnload = (shouldWarn = true) => {
  useEffect(() => {
    if (!shouldWarn) return;

    const handleBeforeUnload = e => {
      if (bypassBeforeUnload) return;
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldWarn]);
};
